export enum ProjectNavigationDirection {
    NEXT,
    PREVIOUS,
}

